<div class="unidad-home-container" [ngClass]="{'unidad-modal': isModal}">
  <div class="unidad-info" *ngIf="unidadReady">
    <h2 class="mat-h2">Configuración</h2>
    <div style="padding-bottom: 1.25em" *ngIf="_unidad.createdBy != ''">
      <small>Creada por: <span style="text-transform: lowercase">{{_unidad.createdBy}}</span></small>
    </div>
    <h3 class="mat-h2" *ngIf="_unidad.id == 0" i18n="@@crearUnidad">Crear unidad</h3>
    <form [formGroup]="unidadForm">
      <mat-checkbox disabled formControlName="isActive" color="primary" style="padding-bottom: 1.25em" i18n="@@unidadActiva">
        Unidad activa
      </mat-checkbox>
      <!-- <p>&nbsp;</p> -->
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Nombre de la unidad</mat-label>
        <input readonly matInput i18n-placeholder="@@nombreUnidad" placeholder="Nombre de la unidad" 
          formControlName="nombre" required>
      </mat-form-field>
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Resumen de la unidad</mat-label>
        <textarea matInput i18n-placeholder="@@resumenUnidad" placeholder="Resumen de la unidad"
          formControlName="resumen"></textarea>
      </mat-form-field>
      <div class="inputs-layout" style="margin-bottom: 24px;">
        <mat-form-field *ngIf="alumnosIEPOpts.length > 0" class="inputs-layout__input full-width" appearance="outline">
          <mat-label>Alumnos IEP</mat-label>
          <mat-hint>IEP: Plan Individual de Ajustes. Esta unidad se usará únicamente para los alumnos seleccionados.</mat-hint>
          <mat-select i18n-placeholder="@@alumnosIep" placeholder="Alumnos IEP" formControlName="alumnosIEP" multiple>
            <mat-option *ngFor="let alumno of alumnosIEPOpts" [value]="alumno.id">{{alumno.apellidosNombres}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="inputs-layout">

        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Fecha de inicio</mat-label>
          <input matInput [matDatepicker]="pickerInicia" [min]="fechaIniciaMinMax.min" [max]="fechaIniciaMinMax.max"
            i18n-placeholder="@@fechaInicio" placeholder="Fecha de inicio"
            (dateChange)="dateChange('fechaInicio', $event)" formControlName="fechaInicia" required>
          <mat-datepicker-toggle matSuffix [for]="pickerInicia"></mat-datepicker-toggle>
          <mat-datepicker #pickerInicia></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Fecha de finalización</mat-label>
          <input matInput [matDatepicker]="pickerFin" [min]="fechaFinMinMax.min" [max]="fechaFinMinMax.max"
            i18n-placeholder="@@fechaFinalizacion" placeholder="Fecha de finalización"
            (dateChange)="dateChange('fechaFin', $event)" formControlName="fechaFin" #pickerFinInst required>
          <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
          <mat-datepicker #pickerFin></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Fecha de publicación</mat-label>
          <input matInput [matDatepicker]="pickerPublicar" [min]="fechaPubMinMax.min" [max]="fechaPubMinMax.max"
            i18n-placeholder="@@fechaPublicacion" placeholder="Fecha de publicación" formControlName="fechaPublicar">
          <mat-datepicker-toggle matSuffix [for]="pickerPublicar"></mat-datepicker-toggle>
          <mat-datepicker #pickerPublicar></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Clases esperadas</mat-label>
          <input matInput i18n-placeholder="@@numeroClases" placeholder="Número de clases esperadas"
            formControlName="clasesEsperadas" type="number">
        </mat-form-field>
        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Editores</mat-label>
          <mat-select disabled i18n-placeholder="@@editores" placeholder="Editores" formControlName="editores" multiple>
            <mat-option *ngFor="let profesor of profesoresOpts" [value]="profesor.id">
              {{profesor.nombresApellidos}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="inputs-layout__input" appearance="outline">
          <mat-label>Materias</mat-label>
          <mat-select disabled (openedChange)="seleccionMCP($event)" i18n-placeholder="@@materias" placeholder="Materias"
            formControlName="materiasPeriodo" multiple required>
            <mat-option *ngFor="let materia of materiasPeriodoOpts" [value]="materia.id">
              {{materia.nombreCompleto}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <app-unidad-form-classroom [unidadForm]="unidadForm" [materias]="materias" [unidad]="_unidad">
      </app-unidad-form-classroom>
    </form>
    <mat-dialog-actions>
      <div *ngIf="isModal; else noModal">
        <button mat-button mat-dialog-close i18n="@@cancelar">Cancelar</button>
        <button mat-raised-button (click)="guardar(false)" color="primary" [disabled]="unidadForm.invalid || guardando"
          i18n="@@guardarCerrar">
          Guardar y cerrar
        </button>
        <button mat-raised-button (click)="guardar(true)" color="primary" [disabled]="unidadForm.invalid || guardando"
          i18n="@@guardarUnidad">
          Guardar e ir a unidad
        </button>
      </div>
      <ng-template #noModal>
        <button mat-raised-button (click)="guardar(false)" color="primary" [disabled]="unidadForm.invalid || guardando"
          i18n="@@guardar">Guardar</button>
      </ng-template>
    </mat-dialog-actions>
    <p>&nbsp;</p>
    <div class="cm-botones" *ngIf="guardando">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </div>
  <!-- Aquí meteremos gráficos estadísticos de la unidad <div class="unidad-data"></div> -->
</div>
